import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { LogCategory, LoggerService, LogPage, LogType } from '../../../core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';

@Component({
    selector: 'profile-detail',
    templateUrl: './profile-detail.component.html',
    styleUrls: ['./profile-detail.component.scss'],
    standalone: false
})
export class ProfileDetailComponent implements OnInit, OnDestroy {

    private _person: any;
    
    public personId: string;
    public profileDetail$: Observable<any>;
    public hasLinkedIn: boolean;
    public linkedIn: string;
    public hasPage: boolean;
    public webpage: string;
    @Input() searchterm: string;

    constructor(        
        private logger: LoggerService,                       
        public profileService: ProfileService,
        public activeModal: NgbActiveModal
    ) {
        this.log("constructor", "", LogCategory.Constructor);        
    }

    get person(): any {
        return this._person;
    }

    @Input()
    set person(value: any) {
        if (value) {            
            this._person = value;            
            this.personId = this._person.PersonId;
            this.getPersonProfile();
        }
      
    }
    
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.People, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init); 
    }

    getPersonProfile(): void {
        if (this.personId != '') {
            this.profileDetail$ = this.profileService.fetchProfile$(this.personId).pipe(

                tap((data) => {
                    for (var i = 0; i < data.profile.length; i++) {
                        if (data.profile[i].name == 'LinkedIn' && data.profile[i].value != '') {
                            this.linkedIn = data.profile[i].value;
                            this.hasLinkedIn = true;
                        }
                        if (data.profile[i].name == 'Bio page') {
                            this.webpage = data.profile[i].value;
                            this.hasPage = true;
                        }
                    }
                }),
                map((data) => {
                    if (data?.biodata) {
                        data.biodata.photoUrl = this.profileService.getPhotoUrl(data.biodata.id),
                        data.biodata.failedPhotoUrl = 'assets/images/profile_well.png'
                    }
                    return data;
                }),
                shareReplay(1));
        }
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "Unsubscribing fetchProfile$, params", LogCategory.Destroy);
    }
}
